'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/Info.es.js";
const e = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: a$1 }));
e.displayName = "InfoIcon";
const c = e;
export {
  c as Info,
  e as InfoIcon
};
